import React, { useEffect, useRef, useState } from "react";

function Rating() {
    function NumberAnimation({ value, duration = 2000 }) {
      const [count, setCount] = useState(0);
      const ref = useRef();
    
      useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              // Start animation each time component enters viewport
              let startTimestamp = null;
              const end = parseInt(value, 10);
    
              const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                setCount(Math.floor(progress * end));
                if (progress < 1) requestAnimationFrame(step);
              };
    
              requestAnimationFrame(step);
            }
          },
          { threshold: 0.5 }
        );
    
        if (ref.current) observer.observe(ref.current);
    
        return () => {
          if (ref.current) observer.unobserve(ref.current);
        };
      }, [value, duration]);
    
      return (
        <span
          ref={ref}
          style={{
            display: "inline-block",
            minWidth: "1em",
            minHeight: "1em",
          }}
        >
          {count}
        </span>
      );
    }

  return (
    <>
      <section className=" ps   bg_light">
        <div className="container">
          <div className="text-center">
            <img
              src="/assets/img/star.svg"
              alt="star"
              className="img-fluid h35 mb-4"
            />
            <p className="mb-4 text-center h3">
              “   <img src="/assets/img/logo-white.svg" alt="about-logo" className=' ms-2 me-3 logo_white' /> gave me more than test results — it gave me a roadmap. 
              <br />
              Now I know exactly what my risks are and how to manage them.
              <br /> Every choice I make supports my long-term health.”
            </p>
            <a href="/casestudies" className="d-inline-block  ">
              {" "}
              See case studies <i className="bi bi-chevron-right" />{" "}
            </a>
          </div>
          <div className="row mt-4 mt-md-5 pt-4">
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="star_item_box">
                <h3><NumberAnimation value={78} duration={1000} />%</h3>
                <p className="mb-0">
                  <span>Reported measurable improvements in</span> energy, sleep
                  quality, and stress resilience within the first 90 days of
                  following their EPLIMO plan
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="star_item_box">
                <h3><NumberAnimation value={84} duration={1000} />%</h3>
                <p className="mb-0">
                  <span>
                    Said personalized nutrition &amp; fitness recommendations
                    made it
                  </span>{" "}
                  easier to adopt healthy habits and stick to them compared to
                  generic advice
                </p>
              </div>
            </div>
            <div className="col-md-4  ">
              <div className="star_item_box">
                <h3><NumberAnimation value={72} duration={1000} />%</h3>
                <p className="mb-0">
                  <span>
                    Identified at least one major health risk early (such as
                    diabetes, hypertension, or vitamin deficiency)
                  </span>{" "}
                  that traditional checkups had missed
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Rating;
